import { Api } from "@/api";
import { UserLoginType, RoleType } from "@/DTO";

export const GetRoleById = (user: UserLoginType, id: string) => {
  return new Promise<{
    data: RoleType
  }>((resolve, reject) => {
    const api = new Api({
      method: "get",
      path: `role/${id}`,
      header: {
        Authorization: "Bearer " + user.accessToken,
        "Content-Type": "application/json"
      }
    });
    return api
      .call()
      .then((data: any) => {
        return resolve({
          data: ConvertToRoleType(data.data)
        });
      })
      .catch((err: any) => {
        return reject(err);
      });
  });
};

export const ConvertToRoleType = (item: any): RoleType => {
  return {
    id: item.id,
    title: item?.title,
    permission_list: item?.permission_list,
    created_at: item?.created_at,
  };
};

